import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { addContainerToInstanceQuery } from '../apis';

const useAddContainerToInstance = () => {
  return useMutation({
    mutationFn: addContainerToInstanceQuery,
    onSuccess: () => {
      toast.success('Container added successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error adding container:', error);
    },
  });
};

export default useAddContainerToInstance;
